package gr.tech.GRAttestation.util

object Constants {
    const val FONT_FAMILY = "Arial"
    const val SIDE_PANEL_WIDTH = 250
    const val PAGE_WIDTH = 1920

    const val ADMIN_TABLE_SIZE_DEFAULT = 20

    object DESIGN {
        const val MODAL_OVERLAY_INDEX = 999
    }

    object VALIDATIONS {
        const val EMAIL_MIN_LENGTH = 6
        const val EMAIL_MAX_LENGTH = 256
        val EMAIL_REGEX = Regex("^[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}$")

        const val PASSWORD_MIN_LENGTH = 8
        const val PASSWORD_MAX_LENGTH = 128

        const val NAME_MIN_LENGTH = 1
        const val NAME_MAX_LENGTH = 50
    }

    object FORM {
        const val SALES_DATA_LIMIT = 8
        const val EFF_START_DATE = "January 1, 2026"
        const val EFF_END_DATE = "December 31, 2026"
    }
}

/*
    ENSURE THE SAME AS BACKEND END
 */
object ROUTES {
    const val IS_DEV: Boolean = false
    val BACKEND_URL = if (IS_DEV) "http://localhost:8081" else "/api"


    val FRONTEND_URL = if (IS_DEV) "http://localhost:8080" else "https://retail.greenrebates.com"

    object BACKEND {

        object AUTH {
            val USER_OAUTH_LOGIN = "${BACKEND_URL}/login-auth"
            val USER_SIGN_OUT = "${BACKEND_URL}/logout"

            // TODO add admin to these URLS and append to backend routes.
            val ADMIN_CHECK_AUTH = "${BACKEND_URL}/check-auth"


            val STORE_USER_CHECK_AUTH = "${BACKEND_URL}/store-users/check-auth"

            val STORE_USER_CRED_LOGIN = "${BACKEND_URL}/store-users/login"
            val STORE_USER_SIGN_OUT = "${BACKEND_URL}/store-users/logout"

            val STORE_USER_RESET_PASSWORD_EMAIL = "${BACKEND_URL}/store-users/reset-pass-email"
            val STORE_USER_RESET_TOKEN_CHECK = "${BACKEND_URL}/store-users/reset-token-check"
            val STORE_USER_RESET_PASSWORD = "${BACKEND_URL}/store-users/reset-pass"

            val STORE_USER_REGISTER_TOKEN_CHECK = "${BACKEND_URL}/store-users/register-check"
            val STORE_USER_REGISTER_FINISH = "${BACKEND_URL}/store-users/register-finish"
        }

        object USER_INFO {
            val USER = "${BACKEND_URL}/user"
            val USER_ME = "${BACKEND_URL}/user/me"
            val USER_ME_PFP = "${BACKEND_URL}/user/me/pfp"
        }

        object STORES {
            val STORE_USERS_STORES = "${BACKEND_URL}/stores"


            val ADMIN_STORES = "${BACKEND_URL}/admin/stores"
            val ADMIN_STORES_DELETE = "${BACKEND_URL}/admin/stores"

            val ADMIN_STORE_USERS = "${BACKEND_URL}/admin/store-users"
            val ADMIN_STORE_USERS_INVITES = "${BACKEND_URL}/admin/store-users/invites"
        }

        object SKUS {
            val SKUS = "${BACKEND_URL}/stores/skus"

            val ADMIN_SKUS = "${BACKEND_URL}/admin/skus"
            val ADMIN_SKUS_DELETE = "${BACKEND_URL}/admin/skus"
        }

        object FORMS {
            val FORMS = "${BACKEND_URL}/stores/forms"
            val FORMS_DOWNLOAD = "${BACKEND_URL}/stores/forms/download"

            val ADMIN_FORMS = "${BACKEND_URL}/admin/forms"
            val ADMIN_FORM_DOWNLOAD = "${BACKEND_URL}/admin/forms/download"
            val ADMIN_FORM_PREVIEW = "${BACKEND_URL}/admin/forms/preview"
            val ADMIN_FORMS_DELETE = "${BACKEND_URL}/admin/forms"
            val ADMIN_FORMS_SUMMARY = "${BACKEND_URL}/admin/forms/summary"
        }

        object ACTIVITY {
            val ACTIVITIES = "${BACKEND_URL}/admin/activity"
            val RECEIPTS = "${BACKEND_URL}/admin/activity/receipts"

            val FORMS_SUMMARY = "${BACKEND_URL}/admin/activity/summary/forms"
            val STORE_SUMMARY = "${BACKEND_URL}/admin/activity/summary/store"
            val ADMIN_SUMMARY = "${BACKEND_URL}/admin/activity/summary/admin"

        }
    }
}

/*
    ENSURE THE SAME AS BACKEND END
 */
object RESOURCES {
    const val PROFILE_PICTURE_BYTE_LIMIT = 5L * 1024 * 1024 // 1 kilobyte = 1024 bytes, 1mb = 1024 kilobytes = 5 MB
    const val PROJECT_IMAGE_BYTE_LIMIT = 20 * 1024 * 1024 // 1 kilobyte = 1024 bytes, 1mb = 1024 kilobytes = 10 MB //TODO change back to 10!
}
